import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import React from 'react';

const CustomSwitch = ({id, checked, label, onChange}) => {
  const handleChange = (e) => {
    e.target.id = id;
    onChange(e);
  };
  return <FormControlLabel id={id} checked={checked} control={<Switch />} label={label} onChange={handleChange} />;
};

export default CustomSwitch;
